import { Shirt } from '@/assets/images';
import type { IAvatarAccessory } from '../types';

export const SHIRT: IAvatarAccessory[] = [
  {
    id: 'SH023',
    available: true,
    colorPicker: true,
    name: 'Shirt_Hoodie2',
    icon: <img src={Shirt.Shirt23} />,
    colors: ['#FFBC0D', '#A89386', '#1EC383', '#9A488B']
  },
  {
    id: 'SH024',
    available: true,
    colorPicker: true,
    name: 'Shirt_Hoodie3',
    icon: <img src={Shirt.Shirt24} />,
    colors: ['#DB0007', '#A89386', '#1EC383', '#9A488B']
  },
  {
    id: 'SH025',
    available: true,
    colorPicker: true,
    name: 'Shirt_OversizedShirt1',
    icon: <img src={Shirt.Shirt25} />,
    colors: ['#DB0007', '#A89386', '#1EC383', '#9A488B']
  },
  {
    id: 'SH026',
    available: true,
    colorPicker: true,
    name: 'Shirt_OversizedShirt2',
    icon: <img src={Shirt.Shirt26} />,
    colors: ['#FFBC0D', '#A89386', '#1EC383', '#9A488B']
  },
  {
    id: 'SH027',
    available: true,
    colorPicker: true,
    name: 'Shirt_OversizedShirt3',
    icon: <img src={Shirt.Shirt27} />,
    colors: ['#151515', '#A89386', '#1EC383', '#9A488B']
  },
  {
    id: 'SH028',
    available: true,
    colorPicker: true,
    name: 'Shirt_Kandoora',
    icon: <img src={Shirt.Shirt28} />,
    colors: ['#FFFFFF', '#151515', '#A89386', '#8DA8C4']
  },
  {
    id: 'SH029',
    available: true,
    colorPicker: true,
    name: 'Shirt_KandooraAlt1',
    icon: <img src={Shirt.Shirt29} />,
    colors: ['#FFFFFF', '#151515', '#A89386', '#8DA8C4']
  },
  {
    id: 'SH030',
    available: true,
    colorPicker: true,
    name: 'Shirt_KandooraAlt2',
    icon: <img src={Shirt.Shirt30} />,
    colors: ['#FFFFFF', '#151515', '#A89386', '#8DA8C4']
  },
  {
    id: 'SH031',
    available: true,
    colorPicker: true,
    name: 'Shirt_Abaya',
    icon: <img src={Shirt.Shirt31} />,
    colors: ['#151515', '#A89386', '#8DA8C4', '#DFADB6']
  },
  {
    id: 'SH032',
    available: true,
    colorPicker: true,
    name: 'Shirt_AbayaAlt1',
    icon: <img src={Shirt.Shirt32} />,
    colors: ['#151515', '#A89386', '#8DA8C4', '#DFADB6']
  },
  {
    id: 'SH033',
    available: true,
    colorPicker: true,
    name: 'Shirt_AbayaAlt2',
    icon: <img src={Shirt.Shirt33} />,
    colors: ['#151515', '#A89386', '#8DA8C4', '#DFADB6']
  },
  {
    id: 'SH001',
    available: true,
    colorPicker: false,
    name: 'Shirt_Andersen',
    icon: <img src={Shirt.Shirt1} />
  },
  {
    id: 'SH002',
    available: true,
    colorPicker: true,
    name: 'Shirt_Frida',
    icon: <img src={Shirt.Shirt2} />,
    colors: ['#DB0007', '#FFBC0D', '#E87531', '#DB0C67']
  },
  {
    id: 'SH003',
    available: true,
    colorPicker: false,
    name: 'Shirt_MLK',
    icon: <img src={Shirt.Shirt3} />
  },
  {
    id: 'SH004',
    available: true,
    colorPicker: true,
    name: 'Shirt_Amalia',
    icon: <img src={Shirt.Shirt4} />,
    colors: ['#8C4900', '#E97B98', '#9C9C9C', '#33BFD2']
  },
  /* {
    id: 'SH005',
    available: true,
    colorPicker: false,
    name: 'Shirt_Senna',
    icon: <img src={Shirt.Shirt5} />
  }, */
  {
    id: 'SH006',
    available: true,
    colorPicker: true,
    name: 'Shirt_Einstein',
    icon: <img src={Shirt.Shirt6} />,
    colors: ['#1EC383', '#FFBC0D', '#E87531', '#419EC9']
  },
  /* {
    id: 'SH007',
    available: false,
    colorPicker: false,
    name: 'Shirt_FamilyMode',
    icon: <img src={Shirt.Shirt7} />
  },
  {
    id: 'SH008',
    available: false,
    colorPicker: false,
    name: 'Shirt_AllIGot',
    icon: <img src={Shirt.Shirt8} />
  }, */
  {
    id: 'SH009',
    available: true,
    colorPicker: true,
    name: 'Shirt_Tight',
    icon: <img src={Shirt.Shirt9} />,
    colors: ['#FFBC0D', '#DB0007', '#1EC383', '#9A488B']
  },
  {
    id: 'SH010',
    available: true,
    colorPicker: true,
    name: 'Shirt_Sweatertop',
    icon: <img src={Shirt.Shirt10} />,
    colors: ['#DB0007', '#E87531', '#DB0C67', '#33BFD2']
  },
  {
    id: 'SH011',
    available: true,
    colorPicker: true,
    name: 'Shirt_Backpack',
    icon: <img src={Shirt.Shirt11} />,
    colors: ['#1EC383', '#9A488B', '#E87531', '#419EC9']
  },
  {
    id: 'SH012',
    available: true,
    colorPicker: true,
    name: 'Shirt_Scarf',
    icon: <img src={Shirt.Shirt12} />,
    colors: ['#FFBC0D', '#9A488B', '#1EC383', '#419EC9']
  },
  {
    id: 'SH013',
    available: true,
    colorPicker: true,
    name: 'Shirt_Sweater',
    icon: <img src={Shirt.Shirt13} />,
    colors: ['#FFBC0D', '#E87531', '#DB0C67', '#419EC9']
  },
  {
    id: 'SH014',
    available: true,
    colorPicker: true,
    name: 'Shirt_Shorttop',
    icon: <img src={Shirt.Shirt14} />,
    colors: ['#DB0007', '#E87531', '#DB0C67', '#419EC9']
  },
  {
    id: 'SH015',
    available: true,
    colorPicker: true,
    name: 'Shirt_Top',
    icon: <img src={Shirt.Shirt15} />,
    colors: ['#1EC383', '#9A488B', '#FFBC0D', '#33BFD2']
  },
  {
    id: 'SH016',
    available: true,
    colorPicker: true,
    name: 'Shirt_Cutetop',
    icon: <img src={Shirt.Shirt16} />,
    colors: ['#DB0C67', '#E97B98', '#FFBC0D', '#419EC9']
  },
  {
    id: 'SH017',
    available: true,
    colorPicker: true,
    name: 'Shirt_Cocktail',
    icon: <img src={Shirt.Shirt17} />,
    colors: ['#DB0C67', '#E97B97', '#151515', '#33BFD2']
  }
  /* {
    id: 'SH018',
    available: true,
    colorPicker: true,
    name: 'X_Shirt_Bumberjacket',
    icon: <img src={Shirt.Shirt18} />,
    colors: ['#FFBC0D', '#9A488B', '#1EC383', '#419EC9']
  },
  {
    id: 'SH019',
    available: true,
    colorPicker: true,
    name: 'X_Shirt_Hoody',
    icon: <img src={Shirt.Shirt19} />,
    colors: ['#DB0008', '#E87532', '#DB0C68', '#33BFD2']
  },
  {
    id: 'SH020',
    available: false,
    colorPicker: false,
    name: 'X_Shirt_Medal',
    icon: <img src={Shirt.Shirt20} />
  },
  {
    id: 'SH021',
    available: true,
    colorPicker: true,
    name: 'X_Shirt_Topje',
    icon: <img src={Shirt.Shirt21} />,
    colors: ['#FFBC0D', '#9A488B', '#1EC383', '#419EC9']
  },
  {
    id: 'SH022',
    available: true,
    colorPicker: true,
    name: 'X_Shirt_Turtleneck',
    icon: <img src={Shirt.Shirt22} />,
    colors: ['#DB0008', '#E87532', '#DB0C68', '#33BFD2']
  } */
];
